// extracted by mini-css-extract-plugin
export default {"progress_wrap":"SkillsSection_progress_wrap__Wos0l"};